import { Heading as BaseHeading } from "@chakra-ui/react";

export default BaseHeading;
